<template>
    <ion-row class="" v-if="dokumente.length > 0">
        <ion-col size="12">
            <p class="ion-no-margin">
                Du hast bereits {{ dokumente.length }} Dokumente
            </p>

            <div class="c-bautagebuch-widget">
                <img
                    class="c-bautagebuch-widget__kamel"
                    :src="
                        `${baseurl}/content/dam/klickmal/me1ns/sliderimages/kamel_sprech_linie.png`
                    "
                />
                <div class="c-bautagebuch-widget__jahr -jahr-0">2020</div>
                <div class="c-bautagebuch-widget__jahr -jahr-1">2019</div>
                <div class="c-bautagebuch-widget__jahr -jahr-2">2018</div>

                <template v-for="(file, index) in dokumente">
                    <div
                        :key="index"
                        v-if="index < 4"
                        class="c-bautagebuch-widget__image-wrapper"
                        :class="'-image-' + index"
                    >
                        <img
                            class="c-bautagebuch-widget__image"
                            :src="
                                baseurl +
                                    file.fileThumbnailUrl +
                                    '&TokenId=' +
                                    token
                            "
                        />
                    </div>
                </template>
            </div>
        </ion-col>
    </ion-row>

    <ion-row v-else>
        Du hast noch keine Dokumente
        <img
            class="ion-margin-top"
            :src="
                `${baseurl}/content/dam/klickmal/me1ns/sliderimages/kamel_sprech_linie.png`
            "
        />
    </ion-row>
</template>

<script>
import { BASEURL } from "@/utils/globals";
import { getTokenId } from "@/api/auth";

export default {
    mixins: [],
    props: ["title", "subtitle"],
    data() {
        return {
            baseurl: BASEURL,
            token: "",
            filterData: {
                limitStart: 0,
                // limit: 3,
                limitCategories: 5
            }
        };
    },
    mounted() {
        getTokenId().then(response => {
            if (response.data.Status === 200) {
                this.token = response.data.Result.TokenId;
            }
        });
        this.$store.dispatch("dokbox/getDokboxFiles", this.filterData);
    },
    computed: {
        dokumente() {
            return this.$store.getters["dokbox/images"];
        }
    }
};
</script>

<style lang="scss" scoped>
.c-bautagebuch-widget {
    position: relative;
    // border: solid 1px green;
    overflow: hidden;

    &__kamel {
        float: right;
    }

    &__jahr {
        display: none;
        position: absolute;
        font-size: 10px;
        font-weight: bold;

        &.-jahr-0 {
            left: 7%;
            top: 10%;
            font-size: 14px;
            @media only screen and (min-width: $breakpoint-md) {
            }
        }

        &.-jahr-1 {
            left: 5%;
            top: 55%;
            font-size: 12px;
            @media only screen and (min-width: $breakpoint-md) {
            }
        }

        &.-jahr-2 {
            left: 30%;
            top: 30%;
            @media only screen and (min-width: $breakpoint-md) {
            }
        }
    }

    &__image-wrapper {
        border: solid 2px black;
        width: 26px;
        background: #fff;

        // padding: 5% 5% 10% 5%;
        position: absolute;

        // box-shadow: -10px 10px 10px 2px rgba(0, 0, 0, 0.3);

        // @media only screen and (min-width: $breakpoint-md) {
        //   box-shadow: -10px 10px 20px 2px rgba(0, 0, 0, 0.3);
        // }

        &.-image-0 {
            width: 36px; //even Number
            height: 36px;
            top: 14%;
            left: 10%;

            // box-shadow: -6px 8px 8px 2px rgba(0, 0, 0, 0.27);
            @media only screen and (min-width: $breakpoint-md) {
                top: 15%;
                width: 72px;
                height: 72px;

                box-shadow: -12px 16px 16px 4px rgba(0, 0, 0, 0.35);
            }
        }

        &.-image-1 {
            width: 20px; //even Number
            height: 20px;
            top: 40%;
            left: 15%;

            // box-shadow: -2px 2px 3px 0px rgba(0, 0, 0, 0.4);
            @media only screen and (min-width: $breakpoint-md) {
                width: 40px;
                height: 40px;
                top: 52%;

                box-shadow: -4px 4px 5px 0px rgba(0, 0, 0, 0.48);
            }
        }

        &.-image-2 {
            width: 26px; //even Number
            height: 26px;
            top: 30%;
            left: 40%;

            // box-shadow: -4px 4px 6px 2px rgba(0, 0, 0, 0.29);
            @media only screen and (min-width: $breakpoint-md) {
                width: 52px;
                height: 52px;
                top: 25%;

                box-shadow: -8px 8px 12px 4px rgba(0, 0, 0, 0.38);
            }
        }

        &.-image-3 {
            width: 40px; //even Number
            height: 40px;
            top: 46%;
            left: 33%;

            // box-shadow: -7px 10px 8px 2px rgba(0, 0, 0, 0.25);
            @media only screen and (min-width: $breakpoint-md) {
                width: 80px;
                height: 80px;
                left: 30%;
                top: 55%;

                box-shadow: -14px 20px 17px 4px rgba(0, 0, 0, 0.3);
            }
        }
    }

    &__image {
        border: solid 2px black;
        overflow: hidden;
        margin-bottom: 25%;
        margin-top: 8%; //even Number
        width: 84%; //even Number
        height: 70%; //even Number
        position: relative;
        float: left;
        left: 50%;
        transform: translate(-50%, 0);
        background-size: cover;
    }
}
</style>
